import { render, staticRenderFns } from "./DomainsManage.vue?vue&type=template&id=27c60cdb&scoped=true"
import script from "./DomainsManage.vue?vue&type=script&lang=js"
export * from "./DomainsManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c60cdb",
  null
  
)

export default component.exports